import React from 'react';
import QuoteInbox from './QuoteInbox';
import Header from '../components/Header';

const VendorMessagesPage = () => (
  <div>
    <Header />
    <QuoteInbox role="vendor" />
  </div>
);

export default VendorMessagesPage;
